import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { storeUrl } from "../url";

// ✅ Optional: fetch single product by ID or slug (for refresh case)
export const fetchProductById = createAsyncThunk(
  "product/fetchProductById",
  async (sku) => {
    const { data } = await axios.get(`${storeUrl}/getProduct/${sku}`);
    console.log(data)
    return data[0];
  }
);

const productSlice = createSlice({
  name: "product",
  initialState: {
    selectedProduct: null,
    loading: false,
    error: null,
  },
  reducers: {
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
      localStorage.setItem("selectedProduct", JSON.stringify(action.payload));
    },
    clearSelectedProduct: (state) => {
      state.selectedProduct = null;
      localStorage.removeItem("selectedProduct");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProduct = action.payload;
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setSelectedProduct, clearSelectedProduct } = productSlice.actions;
export default productSlice.reducer;
